import React from 'react';
import { Helmet } from 'react-helmet-async';
import { COMPANY_INFO } from '../mock';

const FAQ_ITEMS_BUNDESWEIT = [
  {
    question: 'Kommt ihr wirklich bundesweit?',
    answer: 'Ja, wir arbeiten deutschlandweit. Die Begutachtung findet direkt vor Ort statt – Sie müssen nicht zu uns fahren.'
  },
  {
    question: 'Wie schnell bekomme ich einen Termin?',
    answer: 'Meist innerhalb von 24–48 Stunden, je nach Region und Verfügbarkeit. Wir koordinieren das flexibel mit Ihnen.'
  },
  {
    question: 'Muss ich irgendwo hinfahren?',
    answer: 'Nein. Die Begutachtung erfolgt dort, wo sich Ihr Fahrzeug befindet – bei Ihnen, in einer Werkstatt oder an einem anderen Ort Ihrer Wahl.'
  },
  {
    question: 'Was, wenn das Auto nicht fahrbereit ist?',
    answer: 'Kein Problem. Wir kommen dorthin, wo das Fahrzeug steht. Teilen Sie uns einfach den Standort mit.'
  },
  {
    question: 'Wie lange dauert die Begutachtung?',
    answer: 'In der Regel 30–60 Minuten vor Ort. Das schriftliche Gutachten erhalten Sie anschließend innerhalb von 2–3 Werktagen.'
  },
  {
    question: 'Was kostet ein Unfallgutachten?',
    answer: 'Die Kosten variieren je nach Schadensumfang und Fahrzeugtyp. Bei unverschuldetem Unfall werden sie oft von der gegnerischen Versicherung übernommen – einzelfallabhängig. Wir klären das gerne im Gespräch.'
  },
  {
    question: 'Wer übernimmt die Kosten?',
    answer: 'Bei unverschuldetem Unfall in der Regel die gegnerische Haftpflichtversicherung. Diese Information ist keine rechtsverbindliche Zusage – jeder Fall ist individuell zu prüfen.'
  },
  {
    question: 'Was passiert nach dem Termin?',
    answer: 'Nach der Begutachtung erstellen wir das Gutachten und senden es Ihnen zu. Sie können es dann bei der Versicherung einreichen.'
  },
  {
    question: 'Kann ich vorher Fragen stellen?',
    answer: 'Ja, selbstverständlich. Kontaktieren Sie uns per Telefon oder WhatsApp – wir klären alle offenen Punkte vorab.'
  },
  {
    question: 'Was brauche ich für den Termin?',
    answer: 'Idealerweise: Fahrzeugschein, Unfallbericht (falls vorhanden), Fotos. Aber keine Sorge – wenn etwas fehlt, klären wir das gemeinsam.'
  },
  {
    question: 'Wie wird der Termin abgestimmt?',
    answer: 'Nach Ihrer Kontaktaufnahme vereinbaren wir gemeinsam einen passenden Zeitpunkt und Ort. Flexibel nach Ihrer Verfügbarkeit.'
  },
  {
    question: 'Arbeitet ihr auch an Wochenenden?',
    answer: 'Je nach Verfügbarkeit und Region können Termine auch außerhalb der üblichen Geschäftszeiten abgestimmt werden. Sprechen Sie uns an.'
  }
];

export const SEOHeadBundesweit = () => {
  const schemaBreadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite",
        "item": "https://www.dein-gutachten-direkt.de/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Bundesweit",
        "item": "https://www.dein-gutachten-direkt.de/bundesweit"
      }
    ]
  };

  const schemaFAQ = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQ_ITEMS_BUNDESWEIT.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Unfallgutachten bundesweit – direkt vor Ort | Dein Gutachten Direkt</title>
      <meta name="title" content="Unfallgutachten bundesweit – direkt vor Ort | Dein Gutachten Direkt" />
      <meta name="description" content="Professionelle Unfallgutachten deutschlandweit. Wir kommen zu Ihnen – schnelle Terminvergabe, strukturierte Dokumentation, unabhängige Bewertung." />
      <meta name="keywords" content="Unfallgutachten bundesweit, mobiler Gutachter, Gutachter vor Ort, deutschlandweit, Schadensbegutachtung" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.dein-gutachten-direkt.de/bundesweit" />
      <meta property="og:title" content="Unfallgutachten bundesweit – direkt vor Ort" />
      <meta property="og:description" content="Professionelle Unfallgutachten deutschlandweit. Wir kommen zu Ihnen." />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://www.dein-gutachten-direkt.de/bundesweit" />
      <meta property="twitter:title" content="Unfallgutachten bundesweit – direkt vor Ort" />
      <meta property="twitter:description" content="Professionelle Unfallgutachten deutschlandweit. Wir kommen zu Ihnen." />

      {/* Canonical */}
      <link rel="canonical" href="https://www.dein-gutachten-direkt.de/bundesweit" />

      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(schemaBreadcrumb)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(schemaFAQ)}
      </script>
    </Helmet>
  );
};